"use strict"

import Vue from 'vue'
import axios from 'axios'

const environment = process.env.NODE_ENV || 'development'

let apiUrl = 'http://127.0.0.1:9100'

if (environment === 'production') {
  apiUrl = 'https://rosa.resol.de'
} else if (environment === 'testing') {
  apiUrl = 'https://rosa-intern.resol.de'
}

let config = {
  baseURL: apiUrl,
  timeout: 30 * 1000
}
const _axios = axios.create(config)

_axios.apiUrl = apiUrl

Plugin.install = function(Vue) {
  Vue.axios = _axios
  window.axios = _axios
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios
      }
    },
    $axios: {
      get() {
        return _axios
      }
    }
  })
}

Vue.use(Plugin)

export default Plugin
